import SliderModule from "../modules/slider";

$(document).ready(() => {
    var sliderModule = new SliderModule(".slider");
    sliderModule.init();
});


// WEBPACK FOOTER //
// ./Content/scripts/pages/produkt.ts